module.exports = __webpack_public_path__ + "media/night/359-3c3228a1.svg";